import { defineMessages } from "@/i18n";
import en from "./en";

export const framesEmailMessages = defineMessages("frames-email", en);
